//function to replace domain with the domain the user is currently on
export function changeDomain() {
  const domain = process.env.LOCALE_ORIGIN;

  if (typeof window !== 'undefined') {
    if (domain) {
      const domainLink = `<a href=${domain}>${domain.slice(domain.lastIndexOf("/") + 1)}</a>`;
      let article = document.querySelector('article');

      if (article.innerHTML.indexOf("{{domain}}") > -1) {
        article.innerHTML = article.innerHTML.replace(/{{domain}}/gmi, domainLink)
      }
    }
  }
}
